import React, { useEffect } from 'react'
import { Box, Typography, AppBar, Toolbar, Stack, useMediaQuery } from '@mui/material'
import AssessmentIcon from '@mui/icons-material/Assessment'
import Application from '../../../layout/Application'
import { BacktestType, ShowcaseProvider, useShowcaseContext } from '../contexts/ShowcaseContext'
import ShowcaseFilterView from '../../../components/backtests/filter/ShowcaseFilterView'
import ShowcaseBacktestReports from '../components/ShowcaseBacktestReports'
import { Tabs } from '../../../layout/MainLayout'
import { useTheme } from '@mui/material/styles'
import { useApplicationSuiteContext } from '../../../contexts/ApplicationSuiteProvider'

function ShowcaseApp() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const { activeTab, setActiveTab } = useApplicationSuiteContext()

  const { setType, setFocusedBacktest } = useShowcaseContext()

  useEffect(() => {
    if (activeTab.tab !== Tabs.Showcase) return

    const { options } = activeTab
    if (!options) return

    const newOptions = { ...options }
    let hasChanges = false

    if (options.type) {
      setType(options.type as BacktestType)
      delete newOptions.type
      hasChanges = true
    }

    if (options.item) {
      setFocusedBacktest(options.item)
      delete newOptions.item
      hasChanges = true
    }

    if (hasChanges) {
      setActiveTab({ tab: Tabs.Showcase, options: newOptions })
    }
  }, [setFocusedBacktest, setActiveTab, activeTab, setType])

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        flexDirection: 'column',
      }}
      px={1}
    >
      {/* Header */}
      <AppBar
        position="static"
        sx={{
          boxShadow: 'none',
          background: 'none',
          borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
          mb: 1,
        }}
      >
        <Toolbar style={{ padding: 0, display: 'flex', gap: 8, minHeight: 56 }}>
          <Stack
            direction={isMobile ? 'column' : 'row'}
            spacing={1}
            alignItems={isMobile ? '' : 'center'}
            sx={{ flexGrow: 1 }}
            mb={isMobile ? '8px' : 0}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <AssessmentIcon sx={{ color: theme.palette.primary.main }} />
              <Typography
                variant="h6"
                component="div"
                sx={{ fontWeight: 700, letterSpacing: '-0.02em' }}
              >
                Backtests
              </Typography>
            </Box>
            <ShowcaseFilterView />
          </Stack>
        </Toolbar>
      </AppBar>

      {/* Main content container */}
      <ShowcaseBacktestReports />
    </Box>
  )
}

const ShowcaseProviderWrapper = ({ children }: any) => {
  return <ShowcaseProvider parentTab={Tabs.Showcase}>{children}</ShowcaseProvider>
}

const App = ({ tab }: any) => (
  <Application AppComponent={ShowcaseApp} ContextProviders={[ShowcaseProviderWrapper]} tab={tab} />
)

export default App
